import React, { Component } from 'react';
import { SlideSection, ComputerSection, CarouselSection, TitlePage } from './index';
import './landing.css';
import { createMuiTheme, ThemeProvider, responsiveFontSizes, CssBaseline } from '@material-ui/core';
import { ParallaxProvider } from 'react-scroll-parallax';

const theme = responsiveFontSizes(createMuiTheme({
    typography: {
        fontFamily: 'Lato, Roboto, sans-serif'
    },
    background: {
        default: '#fff'
    }
}));
class LandingDashboard extends Component {

    render() {
        return (
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <div >
                            <main>
                                <TitlePage
                                    title={["Your Guide On The Side"]}
                                    subtitle="Because a Guided User is a Happy User">
                                </TitlePage>
                                <CarouselSection
                                    titleA="   Onboarding"
                                    descriptionA="Up to 60% of free trial users drop off after their initial visit. Ziplyne reduces churn from day 1 by engaging your users through product-led experiences without overloading your engineers."
                                    titleB="   Adoption"
                                    descriptionB="Adoption is irrelevant without retention!  Ziplyne is designed to maintain meaningful interactions with all your users (both new and returning). "
                                    titleC="   Training"
                                    descriptionC="Now there’s a reliable alternative to videos and live sessions. Ziplyne offers the flexibility to modify and deploy training in real-time based on the role or behavior of the end-user."
                                    titleD="   Support"
                                    descriptionD="Ensuring quality customer support without overburdening your staff can be a challenge. Ziplyne deflects and lowers your ticket count resulting in much happier customers AND employees!">
                                    <div>
                                    </div>
                                </CarouselSection>
                                <ComputerSection
                                    title={["Guidance:", <br />, "The Antidote To Churn"]}
                                    subtitle={["Don’t Just Onboard Your Users…", <br />, "Retain Them!"]}>
                                </ComputerSection>
                                <SlideSection
                                    title="Ziplyne Is guidance made easy"
                                    subtitle="We get it, your content creators are not coders so we’ve designed Ziplyne to enable Zip Content Creation with no coding necessary. Creating Zips is about as easy as creating a Word Document." >
                                </SlideSection>
                            </main>
                        </div>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        )
    }


}

export default LandingDashboard;
